import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../../components/Text'

const Box = styled.li`
  padding: 0 0 0.5rem 0;
  &:last-child {
    padding: 0;
  }
`

export default class Item extends Component {
  render() {
    const { str } = this.props

    return (
      <Box>
        <Text str={str} />
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/OrderedList/Item.js